import API from '@/services/api'
import getPointIdFromStorage from '@/services/getPointId'

export default async function getPlans(pointId) {
  try {
    if (!pointId) {
      pointId = getPointIdFromStorage().id
    }
    const response = await API.get(`plan?point_id=${pointId}`)

    if (response.data) {
      return response.data
    }
    return
  } catch (error) {
    console.log(error)
  }
}
